// geminiService.js
// AIスキャン機能 - Lambda /analyze 経由で Gemini API を呼び出す
// ブラウザから直接 Gemini API を呼ばないため、APIキーが露出しない

const API_BASE = process.env.REACT_APP_API_BASE_URL || '';

// 画像をBase64に変換するヘルパー
async function fileToBase64(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onloadend = () => {
      // "data:image/jpeg;base64,XXXX" → "XXXX" の部分だけ取り出す
      const base64Data = reader.result.split(',')[1];
      resolve(base64Data);
    };
    reader.onerror = reject;
    reader.readAsDataURL(file);
  });
}

// ▼▼▼ 画像解析 ▼▼▼
export const analyzeFoodImage = async (file, lang = 'ja', authToken = null) => {
  try {
    const base64 = await fileToBase64(file);

    const headers = { 'Content-Type': 'application/json' };
    if (authToken) headers['Authorization'] = `Bearer ${authToken}`;

    const res = await fetch(`${API_BASE}/analyze`, {
      method: 'POST',
      headers,
      body: JSON.stringify({
        imageBase64: base64,
        imageMime: file.type || 'image/jpeg',
        lang,
      }),
    });

    if (!res.ok) {
      const err = await res.json().catch(() => ({}));
      throw new Error(err.error || `HTTP ${res.status}`);
    }

    const data = await res.json();
    console.log('Analyze (image) response:', data);
    return data; // { name, carbs, protein, calories, advice }

  } catch (error) {
    console.error('analyzeFoodImage error:', error);
    alert('画像の解析に失敗しました。');
    return null;
  }
};

// ▼▼▼ テキスト解析 ▼▼▼
export const analyzeFoodText = async (text, lang = 'ja', authToken = null) => {
  try {
    const headers = { 'Content-Type': 'application/json' };
    if (authToken) headers['Authorization'] = `Bearer ${authToken}`;

    const res = await fetch(`${API_BASE}/analyze`, {
      method: 'POST',
      headers,
      body: JSON.stringify({ text, lang }),
    });

    if (!res.ok) {
      const err = await res.json().catch(() => ({}));
      throw new Error(err.error || `HTTP ${res.status}`);
    }

    const data = await res.json();
    console.log('Analyze (text) response:', data);
    return data; // { name, carbs, protein, calories, advice }

  } catch (error) {
    console.error('analyzeFoodText error:', error);
    return null;
  }
};